import { Component, PropsWithChildren, ReactNode } from "react"

import Button from "../../libs/ui/buttons/Button"

export interface SinglePageProp {
    show: boolean
    pageNumber: number
    isLast: boolean
    validatePage: Function
    updateActualPageCallBack: Function
    sendCallBack?: Function
}

export interface SinglePageStatus {

}

declare global {
  interface Window {
    goToElem: any
  }
}

class SinglePage extends Component<PropsWithChildren<SinglePageProp>, SinglePageStatus> {
    constructor (props: any) {
        super(props)

        this.forwardPage = this.forwardPage.bind(this)
        this.backwardPage = this.backwardPage.bind(this)
    }

    render(): ReactNode {
        return (
            <>
                { this.props.show &&
                    <>
                        {this.props.children}

                        <div className="col-12 buttonChangePageContainer">
                            { this.props.isLast === false
                                ?   <>
                                        { Number(this.props.pageNumber) > 1 &&
                                            <Button
                                                id={"backward_"+ this.props.pageNumber}
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={this.backwardPage}
                                            >
                                                Indietro
                                            </Button>
                                        }
                                        <Button
                                            id={"forward_"+ this.props.pageNumber}
                                            type="button"
                                            onClick={this.forwardPage}
                                            className="btn btn-secondary"
                                        >
                                            Avanti
                                        </Button>
                                    </>
                                :   <>  
                                        { Number(this.props.pageNumber) > 1 &&
                                            <Button
                                                id={"backward_"+ this.props.pageNumber}
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={this.backwardPage}
                                            >
                                                Indietro
                                            </Button>
                                        }
                                        <Button
                                            id={"send_"+ this.props.pageNumber}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => { this.props.sendCallBack && this.props.sendCallBack() }}
                                        >
                                            Invia
                                        </Button>
                                    </>
                            }
                        </div>
                    </>
                }
            </>
        )
    }

    private forwardPage (e: any) {
        const validation = this.props.validatePage();
        if (validation) {
            validation.then ( (error : undefined | string) => {
                if (error === undefined) {
                    const tmp = e.target.id.split('_')
                    const nextPageNumber = parseInt( 
                        tmp[1]
                    ) + 1

                    this.scrollToTop()

                    this.props.updateActualPageCallBack( nextPageNumber )
                }
            })
        }
    }

    private backwardPage (e: any) {
        const tmp = e.target.id.split('_')
        const nextPageNumber = parseInt( 
            tmp[1]
        ) - 1

        this.scrollToTop()

        this.props.updateActualPageCallBack( nextPageNumber )
    }

    private scrollToTop () {
        // se presente sfrutto lo scrool incluso nelle pagine di wordpress
        const goToElem = window.goToElem

        if (goToElem) {
            goToElem(document.getElementById('formBlock'))
        } 
        else {
            const root = document.querySelector( '#formBlock' )
            root?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        }
    }
}

export default SinglePage